import { Box } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

export const Container = Box.withConfig({
  backgroundColor: 'white',
  paddingY: '$6',
  paddingX: '$3',
  minHeight: '$40',
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity20,
});

export const SwitchContainer = Box.withConfig({
  flex: '1',
  flexDirection: 'row',
  width: 'full',
});

export const LeftContainer = Box.withConfig({
  width: '1/2',
  flexDirection: 'row',
});

export const RightContainer = Box.withConfig({
  width: '1/2',
  padding: '$0.5',
  flexDirection: 'row-reverse',
});

export const QuickPay = Box.withConfig({
  _text: { fontSize: 'lg', fontWeight: 'bold' },
});

export const PaymentContainer = Box.withConfig({
  marginTop: '$5',
});
